import React from "react";
import { Card, Tabs } from "antd";
import CONSTANTS from "../../../util/constant/CONSTANTS";
import Pets from "./tabs/pets";
import Feedback from "./tabs/feedback";
import Subscription from "./tabs/subscription";
import Transaction from "./tabs/transaction";

const UserDetail = () => {
  const menus = {
    pets: <Pets />,
    feedback: <Feedback />,
    subscription: <Subscription />,
    transaction: <Transaction />,
  };

  return (
    <>
      <div >

        <Card className="mt-5">
          <Tabs
            className="p-0 m-0"
            defaultActiveKey="1"
            size="middle"
            type="card"
            items={CONSTANTS.TAB_MENU.USER.map((ele) => {
              return {
                label: `${ele.Label}`,
                key: `${ele.id}`,
                children: menus[ele?.id],
              };
            })}
          />
        </Card>
      </div>
    </>
  );
};

export default UserDetail;
